/** @deprecated - prefer the IFormSelectOptions interface */
export class FormSelectModel {
  constructor(public value: string, public name: string) {}
}
